import { AxiosResponse } from "axios";
import API from "../api";

import { TaskType } from "../models/task.type";

const endpoint = "types/tasks";

const TasksTypesService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${endpoint}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<TaskType[]>> {
    return await API.get(`/${endpoint}`, { params: options });
  },
  async create(taskType: TaskType): Promise<AxiosResponse<TaskType>> {
    return await API.post(`/${endpoint}`, taskType);
  },
  async update(id: number, taskType: TaskType): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${endpoint}/${id}`, taskType);
  },
};

export default TasksTypesService;
